import Vue from 'vue';
import App from './App.vue';
import router from './router';
import '@/assets/css/text.css';
import '@/assets/css/my-element-ui.css';
import '@/assets/css/layout.css';
import '@/assets/css/app-main.css';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';

import VueQuillEditor from 'vue-quill-editor'

import Quill from 'quill'
import ImageUploader from 'quill-image-uploader'

// 注册模块
Quill.register('modules/imageUploader', ImageUploader)

Vue.use(ElementUI, {
    // size: 'small',
    zIndex: 3000
});

Vue.use(VueQuillEditor);

// 创建全局混入 是的所有el-table的表格，都能够默认拥有排序功能，而不用在每一个 el-table-column 中添加 sortable 属性
Vue.mixin({
    // 当组件创建时触发
    created() {
        // 判断当前组件是否为 'ElTableColumn'（即 element-ui 的表格列组件）
        if (this.$options.name === 'ElTable') {
            this.provideDefaultSortable = true;
        }

        if (this.$options.name === 'ElTableColumn') {
            // 如果 'sortable' 属性未被定义或为 false，则为其设置默认值为 true
            if (this.sortable === undefined || this.sortable === false) {
                if (this.$parent && this.$parent.provideDefaultSortable) {
                    if (this.sortable) {
                        this.sortable = true;
                    }
                }
            }
        }
    }
});

// 针对上面的全局混入修改，抑制浏览器控制台报错。因为vue2不允许我们直接修改组件的 prop 属性
Vue.config.warnHandler = function (msg, vm, trace) {
    // 检查消息是否关于直接修改 prop
    if (msg.includes('Avoid mutating a prop directly')) {
        // 检查是否是 `ElTableColumn` 组件
        if (vm.$options.name === 'ElTableColumn' && msg.includes('sortable')) {
             // 如果满足条件，就不做任何事情
        }
    }
};


Vue.config.productionTip = false;

new Vue({
    router, store, render: h => h(App),
}).$mount('#app');
